import { NavLink, Outlet } from 'react-router-dom';
import ErrorBoundary from '@/components/feature/ErrorBoundary';
import AppGate from '@/components/feature/AppGate';
import FinanceAlertWatcher from '@/pages/dashboard/finance/components/FinanceAlertWatcher';

const TABS: { to: string; label: string; icon: string; end?: boolean }[] = [
  { to: '/dashboard/finance', label: "Vue d'ensemble", icon: 'ri-dashboard-3-line', end: true },
  { to: '/dashboard/finance/revenus', label: 'Revenus', icon: 'ri-money-dollar-circle-line' },
  { to: '/dashboard/finance/depenses', label: 'Dépenses', icon: 'ri-shopping-bag-3-line' },
  { to: '/dashboard/finance/tresorerie', label: 'Trésorerie', icon: 'ri-bank-line' },
  { to: '/dashboard/finance/factures', label: 'Factures', icon: 'ri-file-text-line' },
  { to: '/dashboard/finance/devis', label: 'Devis', icon: 'ri-file-list-3-line' },
  { to: '/dashboard/finance/clients', label: 'Clients', icon: 'ri-user-line' },
  { to: '/dashboard/finance/credit', label: 'Crédit', icon: 'ri-book-2-line' },
  { to: '/dashboard/finance/fournisseurs', label: 'Fournisseurs', icon: 'ri-truck-line' },
  { to: '/dashboard/finance/rapports', label: 'Rapports', icon: 'ri-bar-chart-box-line' },
  { to: '/dashboard/finance/parametres', label: 'Paramètres facturation', icon: 'ri-file-settings-line' },
  { to: '/dashboard/finance/ai', label: 'Finance AI', icon: 'ri-sparkling-line' },
];

export default function FinanceLayout() {
  return (
    <AppGate
      nompage="finance"
      appName="Zifek Finance"
      appDescription="Suivez vos revenus, dépenses, trésorerie, factures et la rentabilité de votre commerce — en un seul endroit."
      icon="ri-funds-line"
    >
      <div className="p-4 md:p-6">
      <div className="mb-5">
        <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 flex items-center gap-2">
          <i className="ri-wallet-3-line text-primary-500"></i>
          Zifek Finance
        </h2>
        <p className="text-sm text-foreground-500 mt-1">
          Revenus, dépenses, trésorerie, factures et rentabilité — en un seul endroit.
        </p>
      </div>

      <div className="flex items-center gap-1.5 mb-6 pb-4 border-b border-background-200/70 overflow-x-auto">
        {TABS.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            end={tab.end}
            className={({ isActive }) =>
              `flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                isActive
                  ? 'bg-primary-50 text-primary-700'
                  : 'bg-background-50 border border-background-200/70 text-foreground-600 hover:bg-background-100'
              }`
            }
          >
            <i className={tab.icon}></i>
            {tab.label}
          </NavLink>
        ))}
      </div>

      <FinanceAlertWatcher />
      <ErrorBoundary scope="Finance">
        <Outlet />
      </ErrorBoundary>
      </div>
    </AppGate>
  );
}